function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "star1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 5.128906 20 L 219 20 L 219 224.9375 L 5.128906 224.9375 Z M 5.128906 20 "
})));

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    viewBox: "0 0 224.87999 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "staricon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.429871%,75.289917%,17.649841%)",
      fillOpacity: 1
    },
    d: "M 218.328125 97.394531 C 217.339844 94.351562 214.71875 92.136719 211.566406 91.675781 L 148.078125 82.425781 L 119.6875 24.726562 C 118.277344 21.863281 115.367188 20.046875 112.179688 20.046875 C 108.988281 20.046875 106.078125 21.863281 104.667969 24.726562 L 76.273438 82.425781 L 12.792969 91.675781 C 9.636719 92.136719 7.011719 94.351562 6.03125 97.394531 C 5.046875 100.433594 5.867188 103.773438 8.152344 106.003906 L 54.089844 150.917969 L 43.242188 214.328125 C 42.699219 217.480469 43.996094 220.667969 46.570312 222.546875 C 49.15625 224.425781 52.574219 224.671875 55.394531 223.1875 L 112.179688 193.246094 L 168.960938 223.183594 C 170.1875 223.828125 171.527344 224.148438 172.859375 224.148438 C 174.597656 224.148438 176.324219 223.605469 177.785156 222.542969 C 180.363281 220.667969 181.65625 217.476562 181.113281 214.328125 L 170.269531 150.914062 L 216.207031 106.003906 C 218.492188 103.777344 219.3125 100.433594 218.328125 97.394531 Z M 218.328125 97.394531 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.67f31220.svg";
export { ForwardRef as ReactComponent };